import { Controller } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import { IFormField } from "models/app";

interface Props extends IFormField {
  errors: any;
  control: any;
  required?: boolean;
  defaultValue?: any;
  setValue?: any;
  errorMessage?: string;
  watch?: any;
}

const RHColor: React.FC<Props> = ({
  label,
  name,
  disabled,
  autoFocus,
  control,
  errors,
  required,
  defaultValue,
  onChange,
  onBlur,
  setValue,
  hidden,
  isHorizontal,
  errorMessage,
  internalLabel = false,
  watch,
}) => {
  const value = watch(name);
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <Grid container alignItems={"center"} hidden={hidden} width={"100%"}>
          {!internalLabel && (
            <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 12) : 12}>
              {label && (
                <Typography
                  variant="body2"
                  fontWeight={500}
                  textAlign={"start"}
                  minWidth={"16ch"}
                >
                  {label}
                </Typography>
              )}
            </Grid>
          )}
          <Grid item xs={12} md={label ? (!isHorizontal ? 3 : 3) : 3}>
            <TextField
              fullWidth
              size="small"
              {...field}
              required={required}
              type="color"
              label={internalLabel ? label : ""}
              disabled={disabled}
              autoFocus={autoFocus}
              placeholder=""
              error={!!errors[name]}
              onChange={(e) => {
                onChange && onChange(e.target.value);
                setValue && setValue(name, e.target.value);
              }}
              onBlur={(e) => {
                onBlur && onBlur(e.target.value);
                setValue && setValue(name, e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
                children: label,
                sx: {
                  padding: "0 !important",
                  "& .MuiInputLabel-asterisk": {
                    padding: "0 !important",
                    color: required && !value ? "red" : "text.main",
                    fontSize: "24px",
                  },
                },
              }}
              helperText={errors[name] && `${errors[name].message}`}
              sx={{
                padding: "0 !important",
                margin: "0 !important",
                "& .css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                  padding: "0 !important",
                },
                "& .MuiOutlinedInput-root": {
                  padding: "0 !important",
                  bgcolor: "common.white",
                  "& fieldset": {
                    borderColor: "grey.500",
                    padding: "0 !important",
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            {errorMessage && (
              <Typography
                variant="caption"
                color="error.main"
                textAlign={"start"}
              >
                {errorMessage}
              </Typography>
            )}
          </Grid>
        </Grid>
      )}
    />
  );
};

export default RHColor;
